import { Component, OnInit, Input, forwardRef, Output, EventEmitter, ViewChild, Optional, Inject } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, NgModel, NG_VALIDATORS, NG_ASYNC_VALIDATORS } from '@angular/forms';
import { RadioValue } from '../../models/radio-value';
import { ElementBase } from '../base/element-base';

@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioComponent),
      multi: true
    }
  ]
})
export class RadioComponent extends ElementBase<any> implements OnInit {

  @Input()
  title: string;

  @Input()
  name: string;

  @Input()
  variants: RadioValue[];

  @Output()
  radioClick = new EventEmitter();

  @Output()
  radioChanged = new EventEmitter();

  @ViewChild(NgModel, { static: true }) model: NgModel;

  @Input()
  textInTop: boolean;

  onClick($event): void {
    this.radioClick.emit($event);
  }

  checkedChanged($event): void {
    this.radioChanged.emit($event);
  }

  constructor(
    @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
    @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
  ) {
    super(validators, asyncValidators);
  }

  ngOnInit(): void {
    if (this.value == null && this.variants && this.variants.length !== 0) {
      const variant = this.variants.find(item => item.default) || this.variants[0];
      if (variant) {
        this.writeValue(variant.value);
      }
    }
  }

  writeValue(value: any): void {
    if (this.value !== value) {
      if (value == null) {
        this.onChange(this.value);
        return;
      }
      this.value = value;
      this.radioChanged.emit(value);
    }
  }
}
